<template>
    <div class="wizard">
        <div class="container">
            <div v-if="!isCDesignSection" class="wizard__header">
                <img src="/img/logo-black.png" />
            </div>
            <Dashboard
                v-if="currentSection === SECTIONS.DASHBOARD"
                :onHandleUploadLater="
                    () =>
                        onChangeSection(
                            SECTIONS.UPLOAD_LATER_SOW,
                            SECTIONS.DASHBOARD
                        )
                "
                :onGo="
                    () =>
                        onChangeSection(
                            SECTIONS.EDIT_KICK_OFF_LINE_ITEM,
                            SECTIONS.DASHBOARD
                        )
                "
                :toEditSales="
                    () =>
                        onChangeSection(
                            SECTIONS.EDIT_SALE_LINE_ITEM,
                            SECTIONS.DASHBOARD
                        )
                "
            ></Dashboard>

            <EditSales
                v-if="currentSection === SECTIONS.EDIT_SALES"
                :onChangeSection="onChangeSection"
            />

            <DoYouHaveNewUpsell
                v-if="currentSection === SECTIONS.DO_YOU_HAVE_UPSELL"
                :onChangeSection="onChangeSection"
            />

            <DoYouHaveNewService
                v-if="currentSection === SECTIONS.DO_YOU_HAVE_SERVICE"
                :onChangeSection="onChangeSection"
            />

            <SOW
                v-if="currentSection === SECTIONS.SOW"
                :onChangeSection="onChangeSection"
            ></SOW>

            <Upsell
                v-if="currentSection === SECTIONS.UPSELL"
                :onChangeSection="onChangeSection"
            />
            <Invoices
                v-if="currentSection === SECTIONS.INVOICES"
                :onChangeSection="onChangeSection"
            />
            <FinalDashboard
                v-if="currentSection === SECTIONS.FINAL_DASHBOARD"
                :onConfirm="onConfirm"
                :onChangeSection="onChangeSection"
            />

            <EditKickOffDate
                :onChangeSection="onChangeSection"
                v-if="currentSection === SECTIONS.EDIT_KICK_OFF_LINE_ITEM"
            />

            <ThankYou v-if="currentSection === SECTIONS.THANK_YOU" />

            <NoActions v-if="currentSection === SECTIONS.NO_ACTIONS" />

            <DoYouHaveServiceWithoutSOW
                :onChangeSection="onChangeSection"
                v-if="
                    currentSection === SECTIONS.DO_YOU_HAVE_SERVICE_WITHOUT_SOW
                "
            />

            <EditSaleLineItem
                :onChangeSection="onChangeSection"
                v-if="currentSection === SECTIONS.EDIT_SALE_LINE_ITEM"
            />

            <HystoricalData
                :onChangeSection="onChangeSection"
                v-if="currentSection === SECTIONS.HYSTORICAL_DATA"
            />

            <UploadLaterSOW
                :onChangeSection="onChangeSection"
                v-if="currentSection === SECTIONS.UPLOAD_LATER_SOW"
            />

            <ThankYouUploadSOW
                v-if="currentSection === SECTIONS.THANK_YOU_UPLOAD_SOW"
            />
        </div>
    </div>
</template>

<script>
import Dashboard from "./sections/Dashboard.vue";
import SOW from "./sections/SOW.vue";
import Upsell from "./sections/Upsell.vue";
import EditSales from "./sections/EditSales.vue";
import Invoices from "./sections/Invoices.vue";
import DoYouHaveNewUpsell from "./sections/DoYouHaveNewUpsell.vue";
import DoYouHaveNewService from "./sections/DoYouHaveNewService.vue";
import ThankYou from "./sections/ThankYou.vue";
import FinalDashboard from "./sections/FinalDashboard.vue";
import NoActions from "./sections/NoActions.vue";
import EditKickOffDate from "./sections/EditKickOffDate.vue";
import DoYouHaveServiceWithoutSOW from "./sections/DoYouHavaServiceWithoutSOW";
import EditSaleLineItem from "./sections/EditSaleLineItem.vue";
import HystoricalData from "./sections/HystoricalData.vue";
import UploadLaterSOW from "./sections/UploadLaterSOW.vue";
import ThankYouUploadSOW from "./sections/ThankYouUploadSOW.vue";

import { SECTIONS } from "./consts";

export default {
    name: "AgencyWizard",
    components: {
        Dashboard,
        SOW,
        Upsell,
        EditSales,
        Invoices,
        DoYouHaveNewUpsell,
        DoYouHaveNewService,
        FinalDashboard,
        ThankYou,
        NoActions,
        EditKickOffDate,
        DoYouHaveServiceWithoutSOW,
        EditSaleLineItem,
        HystoricalData,
        UploadLaterSOW,
        ThankYouUploadSOW,
    },
    data() {
        return {
            SECTIONS,
            section: null,
        };
    },

    mounted() {
        this.$store.commit("setCurrentSection", SECTIONS.DASHBOARD);

        this.checkUploadLaterSOW();
    },

    computed: {
        currentSection() {
            return this.$store.getters.getSection;
        },
        prevSection() {
            return this.$store.getters.getPrevComponent;
        },
        // Sections that have been migrated to c-design and render their own
        // header / logo. Used to hide the legacy `.wizard__header` chrome so
        // the page doesn't double up on logos.
        isCDesignSection() {
            return (
                this.currentSection === SECTIONS.DASHBOARD ||
                this.currentSection === SECTIONS.EDIT_SALE_LINE_ITEM ||
                this.currentSection === SECTIONS.INVOICES ||
                this.currentSection === SECTIONS.FINAL_DASHBOARD ||
                this.currentSection === SECTIONS.THANK_YOU ||
                this.currentSection === SECTIONS.NO_ACTIONS ||
                this.currentSection === SECTIONS.THANK_YOU_UPLOAD_SOW ||
                this.currentSection === SECTIONS.DO_YOU_HAVE_SERVICE ||
                this.currentSection === SECTIONS.DO_YOU_HAVE_UPSELL ||
                this.currentSection === SECTIONS.DO_YOU_HAVE_SERVICE_WITHOUT_SOW ||
                this.currentSection === SECTIONS.HYSTORICAL_DATA ||
                this.currentSection === SECTIONS.EDIT_KICK_OFF_LINE_ITEM ||
                this.currentSection === SECTIONS.UPSELL ||
                this.currentSection === SECTIONS.EDIT_SALES ||
                this.currentSection === SECTIONS.SOW ||
                this.currentSection === SECTIONS.UPLOAD_LATER_SOW
            );
        },
    },

    methods: {
        // Back to dashboard
        onChangeSection(section = SECTIONS.DASHBOARD, prevSection) {
            if (section) {
                this.$store.commit("setCurrentSection", section);
            }

            if (prevSection) {
                this.$store.commit("setPrevComponent", prevSection);
            }

            window.scrollTo({ top: 0, behavior: "smooth" });
        },

        onConfirm() {
            this.$store.commit("setCurrentSection", SECTIONS.THANK_YOU);
        },

        checkUploadLaterSOW() {
            const url = new URL(window.location);

            const page = url.searchParams.get("page");
            const sow_id = url.searchParams.get("sow");

            if (page && page === "get_upload_later" && sow_id) {
                this.$store.commit(
                    "setCurrentSection",
                    SECTIONS.UPLOAD_LATER_SOW
                );
                this.$store.commit("setInitUploadLaterSOWFromQuery", {
                    sow_id: sow_id,
                });
            }
        },
    },
};
</script>
